/* ---------------------------------------------------------------------------
 * MD Fashionwear — last-resort filler for the recommendation carousel
 *
 * THE RACE THIS REPLACES
 * Two paths used to fill the carousel on load: md-cart-init.js (walks catalogue
 * pages until it has enough) and md-cart-recs.js's own single-page fetch. They
 * both raced for the same container via the data-ready flag. When the old
 * single-page path won on a worldwide visit it found almost nothing usable — the
 * carousel came out with 10 cards, then on another attempt with none at all.
 *
 * The proper filler is md-cart-init.js. This only steps in if, after a full three
 * seconds, the carousel is still empty and unclaimed — a genuine failure rather
 * than a race. It exists so a broken pool fetch cannot leave the block blank
 * forever.
 *
 * Loaded LAST of the cart scripts.
 * ------------------------------------------------------------------------- */

(function () {
  'use strict';

  function stillEmpty() {
    var host = document.getElementById('md-recs');
    if (!host) return false;
    if (host.getAttribute('data-ready') === '1') return false;
    if (document.querySelectorAll('.md-rec').length > 0) return false;
    return true;
  }

  function rescue() {
    if (!stillEmpty()) return;
    if (window.MDCartInit && window.MDCartInit.fill) {
      window.MDCartInit.fill();
      return;
    }
    if (window.MDCartRecs && window.MDCartRecs.init) window.MDCartRecs.init();
  }

  function boot() {
    setTimeout(rescue, 3000);
    setTimeout(rescue, 6000);

    var rerun = function () { setTimeout(rescue, 3000); };
    document.documentElement.addEventListener('cart:refresh', rerun);
    document.addEventListener('cart:change', rerun);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
